<template>
    <div>
        <div :class="{ 'message': true, 'success': true, 'active': active, 'cookie': true }">
            {{ $t('message.cookiePolicy') }}
            <a @click="accept" href="javascript:void(0);" class="message-button">
                {{ $t('label.accept') }}
            </a>
        </div>
    </div>
</template>
<script>
    import store from '@/store'
    export default {
      name: 'MessageWidget',
      mounted () {
        if (!store.state.cookieAccept) {
          this.open()
        }
      },
      data () {
        return {
          active: false
        }
      },
      methods: {
        open () {
          this.active = true
        },
        accept () {
          store.commit('SET_COOKIE_ACCEPT', true)
          if (window.localStorage) {
            window.localStorage.setItem('cookieAccept', JSON.stringify(true))
          }
          this.active = false
        }
      }
    }
</script>



// WEBPACK FOOTER //
// src/components/widgets/CookieWidget.vue